<template>
  <div class="container lms-wrapper no-right-sidebar">
    <student-header
      @toggle-navbar="toggleNavbar($event)"
      :navbarmode.sync="navbarMode"
      @toggle-filter-drawer="toggleFilterDrawer"
    />
    <div class="lms-sidebar">
      <div class="lms-sidebar-body">
        <div class="card">
          <div class="card-body" :style="`${$store.state.app.isMobile?'overflow-y: auto; height: calc(100vh - 100px)':''}`">
            <student-nav
              @route-changed="toggleNavbar(false)"
              :counts.sync="counts"
            >
              <course-search
                class="mg-t-40"
                :filterParams="filterParams"
                @on-search="searchCourse"
                @on-reset="onReset"
                :key="filterKey"
              />
            </student-nav>
          </div>
        </div>
      </div>
    </div>
    <div class="lms-content" @click="closeLevel2()">
      <div class="lms-content-body">
        <section class="d-none d-lg-inline">
          <div
            class="d-flex align-items-center justify-content-between mg-b-10"
          >
            <ul class="nav nav-line">
              <li class="nav-item">
                <router-link
                  :to="{
                    name: 'lmsCourses',
                    params: {
                      md: 1,
                      cnm: 'null',
                      type: -1,
                      d1: 'null',
                      d2: 'null'
                    }
                  }"
                  class="nav-link"
                  :class="{ active: filterParams.activeId == 1 }"
                  role="button"
                >
                  Бүх нээлттэй сургалт
                  <sup>({{ counts.allCount }})</sup>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  :to="{
                    name: 'lmsCourses',
                    params: {
                      md: 2,
                      cnm: 'null',
                      type: -1,
                      d1: 'null',
                      d2: 'null'
                    }
                  }"
                  class="nav-link"
                  :class="{ active: filterParams.activeId == 2 }"
                  role="button"
                >
                  <sup>
                    <feather type="star" :size="12" :stroke-width="1"></feather>
                  </sup>
                  Заавал хамрагдах сургалт
                  <sup>({{ counts.mustJoinCount }})</sup>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  :to="{
                    name: 'lmsCourses',
                    params: {
                      md: 3,
                      cnm: 'null',
                      type: -1,
                      d1: 'null',
                      d2: 'null'
                    }
                  }"
                  class="nav-link"
                  :class="{ active: filterParams.activeId == 3 }"
                  role="button"
                >
                  Миний үзэж буй сургалт
                  <sup>({{ counts.joinedCount }})</sup>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  :to="{
                    name: 'lmsCourses',
                    params: {
                      md: 4,
                      cnm: 'null',
                      type: -1,
                      d1: 'null',
                      d2: 'null'
                    }
                  }"
                  class="nav-link"
                  :class="{ active: filterParams.activeId == 4 }"
                  role="button"
                >
                  Миний дууссан сургалт
                  <sup>({{ counts.finishedCount }})</sup>
                </router-link>
              </li>
            </ul>
            <div
              class="d-flex align-items-center"
              v-if="
                $store.state.app.activeGroup.id == 9241 ||
                  $store.state.app.activeGroup.id == 9249
              "
            >
              <a
                @click="filterParams.show = !filterParams.show"
                class="d-flex align-items-center btn text-uppercase tx-13 font-weight-bold"
                :class="`${filterParams.show ? 'btn-warning' : 'btn-default'}`"
              >
                <feather
                  type="filter"
                  :size="16"
                  class="tx-primary mg-r-5"
                ></feather
                >Шүүх
              </a>
            </div>
          </div>
          <div
            v-show="
              filterParams.show &&
                ($store.state.app.activeGroup.id == 9241 ||
                  $store.state.app.activeGroup.id == 9249)
            "
            class="row"
          >
            <div class="col-4">
              <date-picker
                class="wd-100p"
                v-model="filterParams.date"
                type="daterange"
                range-separator="To"
                start-placeholder="Эхлэх огноо"
                end-placeholder="Дуусах огноо"
              ></date-picker>
            </div>
            <div class="col-3">
              <!-- <Select placeholder="Төрөл" v-model="filterParams.type" class="wd-100p">
                <Option :value="null">Бүгд</Option>
              </Select> -->
              <loc-type-cascader
                v-model="filterParams.type"
                locTypekey="courseType"
                disableAdd
                class="wd-100p-f"
              />
            </div>
            <div class="col-3">
              <Input
                v-model="filterParams.name"
                placeholder="Хайх нэрээ бичнэ үү"
              />
            </div>
            <div class="col-2">
              <div class="btn-group btn-group-sm">
                <button
                  @click="searchCourse()"
                  type="button"
                  class="btn btn-primary"
                >
                  Хайх
                </button>
                <router-link
                  :to="{
                    name: 'lmsCourses',
                    params: {
                      md: $route.params.md,
                      cnm: 'null',
                      type: -1,
                      d1: 'null',
                      d2: 'null'
                    }
                  }"
                  type="button"
                  class="btn btn-light"
                  >Бүгд</router-link
                >
              </div>
            </div>
          </div>
        </section>

        <vue-custom-scrollbar
          class="row"
          :style="`height: ${getScrollHeight()}`"
        >
          <div v-if="courses.length == 0" class="col-12 tx-color-01">
            Мэдээлэл хоосон байна
          </div>
          <div
            v-else
            v-for="(r, ci) in courses"
            :key="ci"
            class="col-xs-12 col-sm-6 col-md-4 col-lg-6 col-xl-4 col-xxl-3 courses"
          >
            <div class="card card-profile">
              <button
                v-if="r.locType1 != null"
                :class="
                  `btn btn-xs pd-x-15 btn-uppercase rounded-pill pos-absolute l-10 t-10 btn-${
                    $store.state.app.skin.dark ? 'dark' : 'white'
                  }`
                "
              >
                {{ r.locType1.name }}
              </button>
              <img
                :src="`${r.cover}?w=600`"
                class="card-img-top"
                alt="..."
                style="min-height: 200px !important"
              />
              <div class="card-body">
                <div class="mt-n70px" v-show="r.teachers.length>0">
                  <a>
                    <div class="avatar avatar-xxl">
                      <img
                        v-if="r.teachers != null && r.teachers.length > 0"
                        :src="`${r.teachers[0].cover}?w=164&h=164&mode=crop`"
                        :alt="r.teachers[0].name"
                        :title="r.teachers[0].name"
                        class="rounded-circle img-thumbnail border-0 pd-0-f"
                      />
                      <img
                        v-else
                        src="assets/img/default.png?w=144&h=144&mode=crop"
                        alt
                        class="rounded-circle img-thumbnail border-0 pd-0-f"
                      />
                    </div>
                  </a>
                </div>
                <section>
                  <h5
                    class="course-name text-truncate tx-14-f"
                    style="white-space: normal; max-height: 40px; min-height: 40px"
                  >
                    {{ r.name }}
                  </h5>
                </section>
                <section v-if="r.myShare != null" class="mg-t-10">
                  <div class="progress ht-10 mg-b-5">
                    <div
                      role="progressbar"
                      class="progress-bar bg-success"
                      :style="{ width: r.myShare.percent + '%' }"
                    ></div>
                  </div>
                  <div class="d-flex justify-content-between text-muted tx-12">
                    <span
                      >{{ r.myShare.finishedLessonCount }}/{{
                        r.lessonCount
                      }}
                      Биелүүлсэн</span
                    >
                    <span>{{ r.myShare.percent }}%</span>
                  </div>
                </section>
                <section
                  v-else
                  class="mg-t-10"
                  :title="`${r.startDate} - ${r.endDate}`"
                >
                  <div class="progress ht-10 mg-b-5">
                    <div
                      role="progressbar"
                      class="progress-bar bg-warning"
                      :style="{ width: getRemainingPercent(r) + '%' }"
                    ></div>
                  </div>
                  <div class="d-flex justify-content-between text-muted tx-12">
                    <span>Сургалт хаагдахад</span>
                    <span>{{ getRemainingDays(r) }} хоног</span>
                  </div>
                </section>
                <section class="col-12 tx-12 mg-t-10 card-text">
                  <template v-if="r.option.timeCalculationMethod == 9">
                    <div class="d-flex align-items-center">
                      <div
                        class="wd-5 ht-5 bg-secondary rounded-circle pos-relative t--1"
                      ></div>
                      <span class="tx-medium text-muted mg-l-10"
                        >Үргэлжлэх хугацаа</span
                      >
                      <span class="mg-l-auto">
                        <span class="tx-primary font-weight-bold">{{
                          r.days
                        }}</span>
                        хоног
                      </span>
                    </div>
                    <div
                      v-if="r.myShare != null"
                      class="d-flex align-items-center mg-t-10"
                    >
                      <div
                        class="wd-5 ht-5 bg-secondary rounded-circle pos-relative t--1"
                      ></div>
                      <span class="tx-medium text-muted mg-l-10"
                        >Дуусах огноо</span
                      >
                      <span class="tx-primary font-weight-bold mg-l-auto">{{
                        r.endDate | moment("YYYY/MM/DD")
                      }}</span>
                    </div>
                    <div v-else class="d-flex align-items-center mg-t-10">
                      <div
                        class="wd-5 ht-5 bg-secondary rounded-circle pos-relative t--1"
                      ></div>
                      <span class="tx-medium text-muted mg-l-10"
                        >Үзэх хичээл</span
                      >
                      <span class="tx-primary font-weight-bold mg-l-auto">{{
                        r.lessonCount
                      }}</span>
                    </div>
                  </template>
                  <template v-else>
                    <div class="d-flex align-items-center">
                      <div
                        class="wd-5 ht-5 bg-secondary rounded-circle pos-relative t--1"
                      ></div>
                      <span class="tx-medium text-muted mg-l-10"
                        >Эхлэх огноо</span
                      >
                      <span class="tx-primary font-weight-bold mg-l-auto">{{
                        r.startDate | moment("YYYY/MM/DD")
                      }}</span>
                    </div>
                    <div class="d-flex align-items-center mg-t-10">
                      <div
                        class="wd-5 ht-5 bg-secondary rounded-circle pos-relative t--1"
                      ></div>
                      <span class="tx-medium text-muted mg-l-10"
                        >Дуусах огноо</span
                      >
                      <span class="tx-primary font-weight-bold mg-l-auto">{{
                        r.endDate | moment("YYYY/MM/DD")
                      }}</span>
                    </div>
                  </template>
                </section>
                <section class="ht-35">
                  <div
                    v-if="$route.params.md == 1"
                    class="btn-group btn-group-sm wd-100p"
                    role="group"
                  >
                    <router-link
                      v-if="r.myShare != null"
                      :to="{
                        name: 'lmsCourseView',
                        params: { id: r.id, bid: 0, iid: 0, bot: 0 }
                      }"
                      type="button"
                      class="btn btn-success wd-50p"
                      >Үзэх</router-link
                    >
                    <button
                      v-else
                      @click="courseInfo(r)"
                      type="button"
                      class="btn btn-primary wd-50p"
                    >
                      {{
                        r.option.joinType == 9900 || r.option.directJoin == 1
                          ? "Элсэх"
                          : "Бүртгүүлэх"
                      }}
                    </button>
                    <button
                      @click="courseInfo(r)"
                      type="button"
                      :class="
                        `btn bd-0 wd-50p btn-${
                          $store.state.app.skin.dark ? 'dark' : 'light'
                        }`
                      "
                    >
                      Танилцах
                    </button>
                  </div>
                  <div
                    v-else-if="$route.params.md == 2"
                    class="btn-group btn-group-sm wd-100p"
                    role="group"
                  >
                    <router-link
                      v-if="r.myShare != null"
                      :to="{
                        name: 'lmsCourseView',
                        params: { id: r.id, bid: 0, iid: 0, bot: 0 }
                      }"
                      type="button"
                      class="btn btn-success wd-50p"
                      >Үзэх</router-link
                    >
                    <button
                      v-else
                      @click="courseInfo(r)"
                      type="button"
                      class="btn btn-primary wd-50p"
                    >
                      Элсэх
                    </button>
                    <button
                      @click="courseInfo(r)"
                      type="button"
                      :class="
                        `btn bd-0 wd-50p btn-${
                          $store.state.app.skin.dark ? 'dark' : 'light'
                        }`
                      "
                    >
                      Танилцах
                    </button>
                  </div>
                  <div
                    v-else-if="$route.params.md == 3"
                    class="btn-group btn-group-sm wd-100p"
                    role="group"
                  >
                    <router-link
                      :to="{
                        name: 'lmsCourseView',
                        params: { id: r.id, bid: 0, iid: 0, bot: 0 }
                      }"
                      type="button"
                      class="btn btn-success wd-50p"
                      >Үзэх</router-link
                    >
                    <button
                      @click="courseInfo(r)"
                      type="button"
                      :class="
                        `btn bd-0 wd-50p btn-${
                          $store.state.app.skin.dark ? 'dark' : 'light'
                        }`
                      "
                    >
                      Тухай
                    </button>
                  </div>
                  <div
                    v-else-if="$route.params.md == 4"
                    class="btn-group btn-group-sm wd-100p"
                    role="group"
                  >
                    <button
                      v-if="r.certificateView"
                      @click="showCertificate(r)"
                      type="button"
                      class="btn btn-success wd-50p"
                    >
                      Сертификат
                    </button>
                    <router-link
                      v-if="
                        r.option.canViewAfterFinish != undefined &&
                          r.option.canViewAfterFinish
                      "
                      :to="{
                        name: 'lmsCourseView',
                        params: { id: r.id, bid: 0, iid: 0, bot: 0 }
                      }"
                      type="button"
                      class="btn btn-primary wd-50p text-white"
                      >Үзэх</router-link
                    >
                    <button
                      v-if="r.option.canViewExamResult"
                      @click="showMark(r)"
                      type="button"
                      class="btn btn-primary wd-50p"
                    >
                      Дүн харах
                    </button>
                  </div>
                </section>
              </div>
              <div
                class="marker-icon marker-top-right marker-primary pos-absolute t--0 r--0"
                v-if="r.option.joinType == 9900"
              >
                <feather
                  class="mg-l-20 mt-n3"
                  style="overflow: initial"
                  type="star"
                  :size="16"
                ></feather>
              </div>
            </div>
          </div>
        </vue-custom-scrollbar>
      </div>
    </div>
    <b-sidebar
      v-model="filterParams.sideBar"
      title="Шүүх"
      shadow
      right
      width="100%"
    >
      <div class="px-3 py-2 bg-white">
        <div class="row">
          <div class="col-12">
            <date-picker
              class="wd-100p"
              v-model="filterParams.date"
              type="daterange"
              range-separator="To"
              start-placeholder="Эхлэх огноо"
              end-placeholder="Дуусах огноо"
            ></date-picker>
          </div>
          <div class="col-12">
            <Select
              placeholder="Төрөл"
              v-model="filterParams.type"
              class="wd-100p"
            >
              <Option :value="null">Бүгд</Option>
            </Select>
          </div>
          <div class="col-12">
            <Input
              v-model="filterParams.name"
              placeholder="Хайх нэрээ бичнэ үү"
            />
          </div>
        </div>
        <button class="btn btn-primary btn-block">Шүүх</button>
      </div>
    </b-sidebar>
    <b-modal v-model="updateMngNameModal.show" no-close-on-backdrop hide-header>
      <div
        class="
          ht-100p
          d-flex
          flex-column
          justify-content-center
          pd-20 pd-sm-30 pd-md-40
        "
      >
        <span class="tx-color-04">
          <feather type="award" :size="32"></feather>
        </span>
        <h3 class="tx-16 tx-sm-20 tx-md-24 mg-b-15 mg-md-b-20">
          Овог нэрээ монгол бичгээр оруулна уу
        </h3>
        <div>
          Сертификатад хэвлэгдэх өөрийн нэрийг бичихдээ компьютерийн хэлийг English-р тохируулж, CMs Ulaanbaatar фонтын галигаар галиглаж бичнэ үү.
        </div>
        
        <div class="d-flex">
          <form class="pd-20" >
            <div class="form-group mg-b-0 row">
              <label class="col-form-label pd-t-20 d-block">Овог</label>
              <input
                v-model="updateMngNameModal.mngLastName"
                maxlength="50"
                class="form-control"
                placeholder="Овог"
              />
              <div style="font-family: 'CMs Ulaanbaatar'">{{updateMngNameModal.mngLastName}}</div>
            </div>
            <div class="form-group mg-b-0 row">
              <label class="col-form-label pd-t-20 d-block">Нэр</label>
              <input
                v-model="updateMngNameModal.mngFirstName"
                maxlength="50"
                class="form-control"
                placeholder="Нэр"
              />
              <div style="font-family: 'CMs Ulaanbaatar'">{{updateMngNameModal.mngFirstName}}</div>
            </div>
          </form>
        </div>
      </div>
      <template #modal-footer>
        <div class="mg-l-auto">
          <b-button @click="updateMngName()" variant="success">Хадгалах</b-button>
        </div>
      </template>
    </b-modal>
    <b-modal
      v-model="course.modal"
      size="lg"
      centered
      :title="course.obj.name"
      scrollable
    >
      <div class="mg-x-20" v-if="course.modal">
        <!-- <h6 class="mg-b-20">{{course.obj.name}}</h6> -->

        <b-carousel
          v-if="course.obj.teachers.length"
          :interval="4000"
          indicators
          class="ht-200 teachers-carousel"
        >
          <b-carousel-slide
            v-for="(t, i) in course.obj.teachers"
            :key="i"
            img-blank
          >
            <template #img>
              <div class="d-flex">
                <div>
                  <img
                    :src="`${t.cover}?w=144&h=144&mode=pad`"
                    alt
                    class="img-thumbnail border-0 pd-0-f"
                  />
                </div>
                <div class="mg-l-10 pd-t-20">
                  <h6>{{ t.lastName }} {{ t.firstName }}</h6>
                  <p class="mg-b-2 text-muted">Газар нэгж: {{ t.depart }}</p>
                  <p class="mg-b-2 text-muted">
                    Албан тушаал: {{ t.position }}
                  </p>
                  <p class="mg-b-0 text-muted">И мэйл хаяг: {{ t.email }}</p>
                </div>
              </div>
            </template>
          </b-carousel-slide>
        </b-carousel>

        <div class="card mg-t-20">
          <div class="card-body text-left bd">
            <h6 class="bd-l bd-5 bd-gray-500 pd-l-5">Сургалтын агуулга:</h6>
            <p class="gosm-edtr-outer" v-html="course.obj.info"></p>
          </div>
        </div>

        <div class="card mg-t-20">
          <div class="card-body text-left bd">
            <h6 class="bd-l bd-5 bd-gray-500 pd-l-5">Судлах модулиуд:</h6>
            <ol class="mg-l-20">
              <li v-for="(l, i) in course.lessons" :key="i" >
                <div class="d-flex bd-b mg-b-5">
                  {{ l.task }}
                  <a @click="infModule(l)" class="mg-l-auto tx-medium" role="button">
                    Дэлгэрэнгүй
                    <i class="icon ion-md-arrow-forward mg-l-5"></i>
                  </a>
                </div>
              </li>
            </ol>
          </div>
        </div>

        <div class="row">
          <div
            v-for="(c, ii) in course.infos"
            :key="ii"
            class="col-xs-12 col-sm-6 col-md-6 col-lg-4 col-xl-4"
          >
            <div class="card">
              <div class="card-body bd">
                <div class="media">
                  <div class="mg-r-20">
                    <feather :type="c.icon"></feather>
                  </div>
                  <div class="media-body">
                    <h6
                      class="tx-sans tx-uppercase tx-10 tx-spacing-1 tx-color-03 tx-semibold tx-nowrap mg-b-5 mg-md-b-8"
                    >
                      {{ c.title }}
                    </h6>
                    <h6 class="tx-13 tx-normal mg-b-0">{{ c.value }}</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <template #modal-footer>
        <div class="text-center wd-100p">
          <router-link
            :to="{
              name: 'lmsCourseView',
              params: { id: course.obj.id, bid: 0, iid: 0, bot: 0 }
            }"
            v-if="course.obj.isJoined"
            class="btn btn-sm pd-x-15 btn-success btn-uppercase"
            >Үзэх</router-link
          >
          <router-link
            :to="{
              name: 'lmsAttend',
              params: { id: course.obj.id, s1: 0, s2: 0 }
            }"
            v-else-if="course.obj.option.joinType == 9900"
            class="btn btn-sm pd-x-15 btn-primary btn-uppercase"
            >Элсэх</router-link
          >
          <button
            @click="directJoinToCourse(course.obj)"
            v-else-if="course.obj.option.directJoin == 1"
            class="btn btn-sm pd-x-15 btn-primary btn-uppercase"
          >
            Элсэх
          </button>
          <router-link
            :to="{
              name: 'lmsAttend',
              params: { id: course.obj.id, s1: 0, s2: 0 }
            }"
            v-else
            class="btn btn-sm pd-x-15 btn-primary btn-uppercase"
            >Бүртгүүлэх</router-link
          >
        </div>
      </template>
    </b-modal>
    
    <b-modal v-model="certificateModal.show" hide-footer hide-header>
      <div
        class="ht-100p d-flex flex-column justify-content-center pd-20 pd-sm-30 pd-md-40"
      >
        <span class="tx-color-04">
          <feather type="award" :size="32"></feather>
        </span>
        <h3 class="tx-16 tx-sm-20 tx-md-24 mg-b-15 mg-md-b-20">
          {{ certificateModal.title }}
        </h3>
        <p
          class="tx-14 tx-md-16 tx-color-02"
          v-html="certificateModal.text"
        ></p>
        
        <div v-if="certificateModal.show" class="d-flex btn-group">
          <a @click="onCertificateRe" class="btn btn-warning btn-uppercase">
              Сертификат шинэчлэх
            </a>
          <a :href="certificateModal.url" target="_blank"
            class="btn btn-success btn-uppercase"
            >Сертификат татаж авах</a>
        </div>
      </div>
    </b-modal>
    <b-modal v-model="courseExamResult.show" hide-footer hide-header>
      <div
        class="ht-100p d-flex flex-column justify-content-center pd-20 pd-sm-30 pd-md-40"
      >
        <span class="tx-color-04">
          <feather type="award" :size="32"></feather>
        </span>
        <h3 class="tx-16 tx-sm-20 tx-md-24 mg-b-15 mg-md-b-20">
          Шалгалтын дүн
        </h3>
        <p class="tx-22 tx-md-16 tx-color-02 text-center">
          {{ courseExamResult.result.toFixed(2) }}
        </p>

        <!-- <a
          v-if="courseExamResult.show"
          :href="certificateModal.url"
          target="_blank"
          class="btn btn-primary btn-block btn-uppercase"
        >Сертификат татаж авах</a> -->
      </div>
    </b-modal>

    <b-modal v-model="mdlInf.modal" hide-footer title="Дэлгэрэнгүй">
      <div
        class="ht-100p d-flex flex-column justify-content-center pd-20"
      >
        <h3 class="tx-16 tx-sm-20 tx-md-24">Дэлгэрэнгүй</h3>
        <p v-html="mdlInf.obj.taskDesc" class="tx-22 tx-md-16 tx-color-02"></p>
        <h3 class="tx-16 tx-sm-20 tx-md-24">Зорилго</h3>
        <p v-html="mdlInf.obj.f1" class="tx-22 tx-md-16 tx-color-02"></p>
      </div>
    </b-modal>
  </div>
</template>

<script>
import vueCustomScrollbar from "vue-custom-scrollbar";
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";
import { request } from "@/api/all";

import "element-ui/lib/theme-chalk/index.css";
import { DatePicker, Select, Option, Input } from "element-ui";
import { mapActions } from "vuex";

const moment = require("moment");

export default {
  components: {
    DatePicker,
    Select,
    Option,
    Input,
    vueCustomScrollbar,
    studentHeader: () => ({
      component: import("@/views/modules/lms/student/components/header.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    studentNav: () => ({
      component: import("@/views/modules/lms/student/components/nav.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    courseSearch: () => ({
      component: import(
        "@/views/modules/lms/student/pages/courses/components/search.vue"
      ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    locTypeCascader: () => ({
      component: import("@/components/task/edit/components/locTypeCascader"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    })
  },
  data() {
    return {
      navbarMode: 0,
      filterCourseSidebar: false,
      filterKey: 0,
      filterParams: {
        sideBar: false,
        show: false,
        activeId: 1,
        date: "",
        type: null,
        name: ""
      },
      now: null,
      course: {
        obj: {},
        modal: false,
        infos: [],
        lessons: []
      },
      courses: [],
      counts: {
        allCount: 0,
        finishedCount: 0,
        joinedCount: 0,
        mustJoinCount: 0
      },
      certificateModal: {
        show: false,
        course: null,
        title: "",
        text: "",
        url: ""
      },
      courseExamResult: {
        show: false,
        result: 0
      },
      mdlInf:{
        modal: false,
        obj: false,
      },
      updateMngNameModal: {
        show: false,
        mngFirstName: "",
        mngLastName: "",
      },
    };
  },
  mounted() {
    this.toggleBodyClass("addClass", "app-lms");
    //require('@/assets/scss/pages/course.scss');
    require("@/assets/css/dynamic.lms.css");
    this.init();
  },
  destroyed() {
    this.toggleBodyClass("removeClass", "app-lms");
  },
  methods: {
    ...mapActions(["resetResponsiveLayoutConfig"]),

    updateMngName(){
      request({
        api: { method: "POST", url: "v2/learn/updateMngName" },
        data: {
          mngFirstName: this.updateMngNameModal.mngFirstName,
          mngLastName: this.updateMngNameModal.mngLastName,
          userId: this.$store.state.user.userId,
        },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.$bvToast.toast("Амжилттай", {
            title: "Мэдэгдэл",
            autoHideDelay: 500,
            appendToast: true,
          });
          this.updateMngNameModal.show=false;
          //this.init();
          this.showCertificate( this.certificateModal.course);
          
        }
      });
    },

    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    onCertificateRe() {
      //console.log(this.$store.state.user.userId);
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "v2/learn/RemoveCertificateFile" },
        data: {
          id: this.certificateModal.course.id,
          userId: this.$store.state.user.userId
        },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.showCertificate(this.certificateModal.course);
          this.$bvToast.toast("Амжилттай", {
            title: "Мэдэгдэл",
            autoHideDelay: 500,
            appendToast: true
          });
        }
      });
    },
    toggleNavbar(shown) {
      if (this.navbarMode == 0) {
        this.navbarMode = 1;
        this.toggleBodyClass("addClass", "lms-sidebar-show");
      } else if (this.navbarMode == 1) {
        if (shown) {
          this.toggleBodyClass("addClass", "navbar-nav-show");
        } else {
          this.navbarMode = 0;
          this.toggleBodyClass("removeClass", "lms-sidebar-show");
        }
      }
    },
    toggleFilterDrawer() {
      this.filterParams.sideBar = true;
    },
    // subNavChange(e) {
    //   //this.filterParams.activeId= e;
    //   if (this.navbarMode == 1) {
    //     this.toggleNavbar(false);
    //   }

    //   this.$router.push({
    //     name: "lmsCourses",
    //     params: {
    //       md: e,
    //       cnm: this.$route.params.cnm,
    //       type: this.$route.params.type,
    //       d1: "null",
    //       d2: "null"
    //     }
    //   });
    // },
    init() {
      this.filterParams.activeId = this.$route.params.md;

      let _url = "v2/Learn/GetCourses";
      //console.log(this.$route.params.md);
      switch (this.$route.params.md) {
        case 2:
        case "2":
          _url = "v2/Learn/getMustJoinCourseList";
          break;
        case 3:
        case "3":
          _url = "v2/Learn/myJoinedCourses";
          break;
        case 4:
        case "4":
          _url = "v2/Learn/myFinishedCourses";
          break;
        default:
          break;
      }

      if (this.$route.params.cnm != "null") {
        this.filterParams.name = decodeURI(this.$route.params.cnm);
        this.filterParams.show = true;
      }

      if (this.$route.params.d1 != "null" && this.$route.params.d2 != "null") {
        this.filterParams.date = [
          moment(this.$route.params.d1),
          moment(this.$route.params.d2)
        ];
        this.filterParams.show = true;
      }

      if (this.$route.params.type > -1) {
        this.filterParams.type = this.$route.params.type;
      }

      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: _url },
        data: {
          skip: 0,
          size: 32,
          name:
            this.$route.params.cnm != "null"
              ? decodeURI(this.$route.params.cnm)
              : null,
          startDate:
            this.$route.params.d1 != "null" ? this.$route.params.d1 : null,
          endDate:
            this.$route.params.d2 != "null" ? this.$route.params.d2 : null,
          locTypeId: this.filterParams.type,
          locTypeId1: null,
          //joinOption: this.filterParams.type != null ? 1 : 0
          joinOption: 0
        },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.courses = res.data.courses;
          this.now = res.data.now;
          //console.log(_url+'=> ', res.data.courses, this.filterParams);
        }
      });

      this.initCount();
    },
    initCount() {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "v2/Learn/GetCourseCounts" },
        data: {
          locTypeId: this.filterParams.type
        },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.counts = res.data;
        }
      });
    },
    courseInfo(c) {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "GET", url: "V2/Learn/courseDetail" },
        params: { id: c.id },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          //console.log('res.data.course', res.data.course);
          this.course.obj = res.data.course;
          this.course.modal = true;
          this.course.infos = [];
          this.course.infos.push({
            id: 1,
            title: "Эхлэх огноо",
            value: moment(res.data.course.date.start).format("YYYY.MM.DD"),
            icon: "calendar"
          });
          this.course.infos.push({
            id: 2,
            title: "Дуусах огноо",
            value: moment(res.data.course.date.end).format("YYYY.MM.DD"),
            icon: "calendar"
          });
          this.course.infos.push({
            id: 3,
            title: "Сургалтын цаг:",
            value: res.data.course.time.toFixed(2) + " цаг",
            icon: "clock"
          });
          this.course.infos.push({
            id: 4,
            title: "Кредит оноо",
            value: res.data.course.creditPoint,
            icon: "clock"
          });

          if(res.data.course.hasExam){
            this.course.infos.push({
              id: 5,
              title: "Шалгалттай эсэх ",
              value: res.data.course.hasExam ? "Тийм" : "Үгүй",
              icon: "pen-tool"
            });
          }
          
          if(res.data.course.lessonExamCount>0){
            this.course.infos.push({
              id: 6,
              title: "Явцын шалгалт ",
              value: res.data.course.lessonExamCount,
              icon: "pen-tool"
            });
          }

          this.course.infos.push({
            id: 7,
            title: "Сертификаттай эсэх",
            value: res.data.course.certificateView == 1 ? "Тийм" : "Үгүй",
            icon: "award"
          });

          if(res.data.course.student.limitView == 1){
            this.course.infos.push({
              id: 8,
              title: "Оролцогчийн лимит",
              value: `${res.data.course.student.count}/${res.data.course.student.limit}`,
              icon: "users"
            });
          }

          this.course.lessons = [];
          let _lsns = res.data.course.boxes.filter(x => x.ot == 114);
          if (_lsns.length > 0) {
            this.course.lessons = _lsns[0].tasks;
          }
        }
      });
    },
    onReset() {
      this.filterKey++;
      this.$router.push({
        name: "lmsCourses",
        params: {
          md: this.$route.params.md,
          cnm: "null",
          type: -1,
          d1: "null",
          d2: "null"
        }
      });
    },
    searchCourse() {
      let _d1 = "null";
      let _d2 = "null";
      if (this.filterParams.date != "") {
        _d1 = moment(this.filterParams.date[0]).format("YYYY-MM-DD");
        _d2 = moment(this.filterParams.date[1]).format("YYYY-MM-DD");
      }

      //console.log(_d1, _d2, this.filterParams.type);

      this.$router.push({
        name: "lmsCourses",
        params: {
          md: this.$route.params.md,
          cnm:
            this.filterParams.name != ""
              ? encodeURI(this.filterParams.name)
              : "null",
          type:
            this.filterParams.type == null ? "null" : this.filterParams.type,
          d1: _d1,
          d2: _d2
          // d1: 'null',
          // d2: 'null',
        }
      });
    },
    getRemainingPercent(c) {
      var today = moment(this.now);
      var start = moment(c.startDate);
      var due = moment(c.endDate);
      return (
        (due.diff(today, "days") * 100) /
        due.diff(start, "days")
      ).toFixed(2);
    },
    getRemainingDays(c) {
      var today = moment(this.now);
      var due = moment(c.endDate);
      return due.diff(today, "days");
    },
    closeLevel2() {
      if (this.$store.state.app.responsiveLayout.level2.show)
        this.resetResponsiveLayoutConfig(document);
    },
    showCertificate(course) {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "V2/Learn/CreateCertificateFromTemplate" },
        data: { id: course.id },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.certificateModal.course = course;

          if (res.data.file.id != 0) {
            this.certificateModal.show = true;
            
            this.certificateModal.url = res.data.file.url;
            this.certificateModal.title = course.name;
          } else {

            if (res.data.updateMngName) {
              this.updateMngNameModal.show = true;
              this.updateMngNameModal.mngFirstName = res.data.mngFirstName;
              this.updateMngNameModal.mngLastName = res.data.mngLastName;
            } else {
            this.$bvToast.toast(
              "Сертификат үүсгэхэд алдаа гарлаа. ахин оролдоно уу",
              {
                title: "Мэдэгдэл",
                autoHideDelay: 500,
                appendToast: true
              }            );
            }
          }
        }
      });
      //
    },
    showMark(course) {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "v2/learn/getCourseExamResult" },
        data: { id: course.id },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.courseExamResult.result = res.data.result;
          this.courseExamResult.show = true;
        }
      });
    },
    getScrollHeight() {
      let mh = 0;

      if (screen.width <= 1024) {
        mh = 80;
      } else {
        mh = this.filterParams.show ? 214 : 150;
      }
      return `calc(${window.innerHeight}px - ${mh}px);`;
    },
    directJoinToCourse(e) {
      //console.log(e);
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "TaskInUser/ShareTaskUser" },
        data: { userId: this.$store.state.user.userId, taskId: e.id },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.$router.push({
            name: "lmsCourseView",
            params: { id: e.id, bid: 0, iid: 0, bot: 0 }
          });
          //console.log(res);
        }
      });
    },
    infModule(l) {
      this.mdlInf.obj= l;
      this.mdlInf.modal= true;
    }
  },
  watch: {
    "$root.$route"() {
      //console.log(newRoute);
      Object.assign(this.$data, this.$options.data());
      this.$nextTick(() => {
        this.init();
      });
    }
  }
};
</script>

<style></style>
